import voiceSplide from './components/voiceSplide';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    voiceSplide();
  },
  false
);
